import React from "react";
import "./Footer.css";
import {
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaLinkedinIn,
  FaTwitter,
  FaPhone,
  FaInstagram,
} from "react-icons/fa";
import logo from "../../assets/Lyros-logo.jpg";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-top">
        {/* Logo + About */}
        <div className="footer-column footer-logo-section">
          <img src={logo} alt="LYROS Logo" className="footer-logo" />
          <p className="footer-welcome">Welcome to Lyros!</p>
          <p className="footer-description">
            Lyros Technologies Pvt. Ltd., established in 2020, is a 
            certified IT services company offering talent acquisition, software
            development, and IT consulting. With offices in Hyderabad,
            Bengaluru, and the USA, Lyros serves 54+ clients and has placed over
            2,000 professionals.
          </p>
        </div>

        {/* Business Verticals */}
        <div className="footer-column">
          <h4 className="footer-heading">Business Verticals</h4>
          <ul className="footer-list">
            <li>
              <Link to="/verticals/workforce-management">
                Workforce Management
              </Link>
            </li>
            <li>
              <Link to="/verticals/global-technology">
                Global Technology Solutions
              </Link>
            </li>
            <li>
              <Link to="/verticals/it-ites">
                IT & ITES Staff Augmentation
              </Link>
            </li>
               <li>
              <Link to="/verticals/digital-marketing">
               Digital Marketing
              </Link>
            </li>
          </ul>
        </div>

        {/* Company */}
        <div className="footer-column">
          <h4 className="footer-heading">Company</h4>
          <ul className="footer-list">
            <li>
              <Link to="/aboutus">About Us</Link>
            </li>
            <li>
              <Link to="/contact">Contact US</Link>
            </li>
      <li>
              <Link to="/careers">Careers</Link>
            </li> 
          </ul>
        </div>
        

        {/* Contact */}
        <div className="footer-column">
          <h4 className="footer-heading">Contact</h4>
          <div className="footer-contact-item">
            <FaEnvelope className="footer-icon" />
            <span>
              <strong>Email Address</strong>
              <br />
              hr@lyrostech.com
            </span>
           
          </div>
           <div className="footer-contact-item">
                    <FaPhone className="footer-icon" />
            <span>
              <strong>Phone Number</strong>
              <br />
            +919133456915
            </span>
          </div>
       
          
          <div className="footer-contact-item">
            <FaMapMarkerAlt className="footer-icon" />
            <span>
              <strong>USA Office:</strong>
              <br />
              22361 NW Brooksideway Lake
              <br />
              Barrington, IL 60010
            </span>
          </div>
          

          <div className="footer-contact-item">
            <FaMapMarkerAlt className="footer-icon" />
            <span>
              <strong>India Offices:</strong>
              <br />
              Q–2, A1, 7<sup>th</sup> Floor,
              <br />
              Cyber Towers, Hitech City,
              <br />
              Hyderabad, Telangana, India – 500081
            </span>
          </div>

          <div className="footer-contact-item">
            <FaMapMarkerAlt className="footer-icon" />
            <span>
              ā hub: 3<sup>rd</sup> Floor,
              <br /> AUIC - North Campus,
              <br />
              Andhra University, Visakhapatnam,
              <br />
              Andhra Pradesh, India – 530003
            </span>
          </div>
          <div className="footer-contact-item">
            <FaMapMarkerAlt className="footer-icon" />
            <span>
             Tapaswiji Info Park,<sup></sup> TechZOne,
              <br /> 181/185,EPIP Zone,
              <br />
              Whitefield, Bengaluru,
              <br />
              Karnataka, India – 560066
            </span>
          </div>
        </div>

        {/* Follow Us Section */}
        <div className="footer-column follow-us">
          <h4 className="footer-heading">Follow Us</h4>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/LyrosTechnologies/"
              target="_blank"
              rel="noopener noreferrer"
              className="facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.linkedin.com/company/lyros-technologies-pvt-ltd/"
              target="_blank"
              rel="noopener noreferrer"
              className="linkedin"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
              className="twitter"
            >
              <FaTwitter />
            </a>
            <a
              href="https://www.instagram.com/lyros_technologies_?igsh=MW5pNmdjMzh1eXhobA=="
              target="_blank"
              rel="noopener noreferrer"
              className="instagram"
            >
              <FaInstagram />
            </a>
          </div>
        </div>
      </div>

      <hr className="footer-separator" />
      <div className="footer-bottom">
        <p>© 2025 Lyros Technologies Private Limited. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
